import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import CloseIcon from "@mui/icons-material/Close";
import { LoadingButton } from "@mui/lab";
import {
  Grid,
  IconButton,
  Modal,
  Stack,
  TextField,
  Typography,
  InputAdornment,
  Box
} from "@mui/material";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import { LocalizationProvider, MobileDatePicker, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

import dayjs from "dayjs";
import moment from "moment";
import { Postrequestcall } from "../../request/Postrequest";
import { BIGrey, BILightGrey } from "../../assets/helpers";
import { SAVE_CLIENT_SAR } from "../../constant/Apipath";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";

export default function ClientSARAddModal({ isOpen, onClose, data, mode, sarData, reload }) {
  const [loading, setLoading] = useState(false);
  const [weather, setWeather] = useState("");
  const [date, setDate] = useState(dayjs());
  const [time, setTime] = useState(dayjs());
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);
  const [open, setOpen] = useState(false);

  //for multi language
  const LANGUAGE = ClientEnglishFallback.ClientSARAddModal(
    multiLanguageData?.ClientSARAddModal || {}
  );
  const {
    TEXT_JOB,
    TEXT_DATE,
    TEXT_TIME,
    TEXT_WEATHER,
    TEXT_REPORT_CAN_BE_EDITED_WITHIN,
    TEXT_CREATE_REPORT
  } = LANGUAGE;
  useEffect(() => {
    if (mode == "EDIT") {
      setWeather(sarData?.weather);
      setDate(dayjs(sarData?.date));
      setTime(moment.utc(sarData?.time).local());
    }
  }, [isOpen]);

  const handelsaveClientTracker = async () => {
    setLoading(true);
    try {
      const payload = {
        ReturnRecordId: true,
        ReturnRecordError: true,
        UserId: loginData?.userInformation?.UserId,
        SaveList: [
          {
            Id: mode == "EDIT" ? sarData?.id : 0,
            ClientEmployeeId: data.clientEmployeeId,
            ClientEmployeeJobId: data.id,
            Date: dayjs.isDayjs(date)
              ? dayjs(date).format("YYYY-MM-DD")
              : dayjs().format("YYYY-MM-DD"),
            Time: time ? time.toISOString() : "",
            Weather: weather,
            ModifiedBy: loginData?.userInformation?.UserId
          }
        ]
      };
      await Postrequestcall(SAVE_CLIENT_SAR, payload, loginData?.accessToken);
    } catch (error) {
      setLoading(false);
      console.log("handelsaveClientTracker-> Error Saving Client SAR: ", error);
    } finally {
      reload();
      onClose();
      resetData();
    }
    setLoading(false);
  };

  const resetData = () => {
    setWeather("");
    setDate(null);
    setLoading(false);
  };

  return (
    <>
      <Modal
        open={isOpen}
        onClose={() => {
          resetData();
          onClose();
        }}>
        <div className="client-modal-responsive">
          <div className="action-button-container">
            <Stack
              sx={{ padding: {
                xs: 0,
                md: 0,
                lg: 1,
                xl: 1
               }}}>
              <Typography
                sx={{ margin: 0 }}
                style={{
                  color: BIGrey
                }}
                variant="subtitle1"
                gutterBottom>
                {TEXT_JOB}
              </Typography>
              <Typography>{`${data?.jobCode} - ${data?.jobName}`}</Typography>
            </Stack>
            <Stack>
              <IconButton
                size="small"
                onClick={() => {
                  resetData();
                  onClose();
                }}
                sx={{
                  color:
                    selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
                      ? selectedClientData?.AccentColor
                      : BILightGrey
                }}>
                <CloseIcon />
              </IconButton>
            </Stack>
          </div>
          <Stack
            sx={{ padding: {
              xs: 0,
              md: 0,
              lg: 1,
              xl: 1
             }}}>
            <Grid container sx={{ display: "flex", flexDirection: "column" }}>
              <Grid spacing={1} size={12} container>
                <Grid size={8}>
                  <Typography sx={{ margin: 0 }} variant="subtitle1" gutterBottom>
                    {TEXT_DATE}
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    {/* Custom display field */}
                    <Box
                      onClick={() => setOpen(true)}
                      sx={{
                        height: "40px",
                        backgroundColor: "#e4e4e4",
                        borderRadius: "10px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        padding: "0 10px",
                        cursor: "pointer"
                      }}>
                      <span>
                        {date && dayjs.isDayjs(date)
                          ? dayjs(date).isSame(dayjs(), "day")
                            ? `${dayjs(date).format("MMM DD, YYYY")} (Today)`
                            : dayjs(date).format("MMM DD, YYYY")
                          : dayjs().format("MMM DD, YYYY")}
                      </span>
                      <InsertInvitationIcon
                        sx={{
                          color: selectedClientData?.AccentColor,
                          cursor: "pointer"
                        }}
                      />
                    </Box>

                    {/* Hidden DatePicker for functionality */}
                    <MobileDatePicker
                      open={open}
                      onOpen={() => setOpen(true)}
                      onClose={() => setOpen(false)}
                      format="MMM DD, YYYY"
                      value={date}
                      onChange={(newValue) => {
                        setDate(newValue);
                      }}
                      defaultValue={dayjs()}
                      sx={{ display: "none" }} // Hide the actual picker input
                    />
                  </LocalizationProvider>
                </Grid>
                <Grid size={4}>
                  <Typography sx={{ margin: 0 }} variant="subtitle1" gutterBottom>
                    {TEXT_TIME}
                  </Typography>
                  <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <MobileTimePicker
                      slotProps={{
                        textField: {
                          fullWidth: true,
                          size: "small",
                          readOnly: true
                        }
                      }}
                      sx={{
                        "& fieldset": { border: "none" }
                      }}
                      value={dayjs(time)}
                      onChange={(newValue) => {
                        setTime(newValue);
                      }}
                      className="ticket-picker add-support"
                    />
                  </LocalizationProvider>
                </Grid>
              </Grid>
              <Grid size={12}>
                <Typography sx={{ margin: 0 }} variant="subtitle1" gutterBottom>
                  {TEXT_WEATHER}
                </Typography>
                <TextField
                  fullWidth
                  slotProps={{
                    input: {
                      rows: 4,
                      multiline: true,
                      inputComponent: "textarea"
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0",
                      padding: " 5px 10px"
                    },
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                      border: "none"
                    }
                  }}
                  rows={5}
                  style={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px"
                  }}
                  value={weather}
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                    setWeather(inputValue);
                  }}
                />
              </Grid>
              <Grid sx={{ mb: 1,  mt: 1 }}  size={12}>
                <Typography
                  sx={{ margin: 0, 
                    color: BIGrey
                  }}
                  textAlign={"center"}
                  
                  variant="subtitle1"
                  gutterBottom>
                  {TEXT_REPORT_CAN_BE_EDITED_WITHIN}
                </Typography>
              </Grid>
              <Grid>
                <LoadingButton
                  onClick={handelsaveClientTracker}
                  fullWidth
                  style={{
                    marginTop: "10px",
                    background: selectedClientData?.AccentColor,
                    color: "white",
                    borderRadius: "10px",
                    boxShadow: "none",
                    textTransform: "none"
                  }}
                  loadingPosition="start"
                  loading={loading}
                  startIcon={<></>}>
                  {TEXT_CREATE_REPORT}
                </LoadingButton>
              </Grid>
            </Grid>
          </Stack>
        </div>
      </Modal>
    </>
  );
}
